import { Link } from "react-router-dom";
import { wealthChannels } from "../data/channels.js";

export default function Wealth() {
  return (
    <>
      <section className="page-header">
        <div className="wrap">
          <div className="eyebrow">Wealth management</div>
          <h1>Bespoke wealth management for HNW individuals and family offices.</h1>
          <p className="sub">
            Wealth management is provided through Maystone Capital Limited, the
            FCA-authorised principal of the Daksfirst Group. Discretionary portfolios across
            public markets, structured products, and the group&rsquo;s own private credit
            transactions.
          </p>
          <div className="hero-actions" style={{ marginTop: 28 }}>
            <a className="btn btn-primary" href="https://maystone.com" target="_blank" rel="noopener noreferrer">
              Visit Maystone &nbsp;↗
            </a>
            <a className="btn btn-ghost" href="mailto:info@daksfirst.com?subject=Wealth%20management%20enquiry">
              Speak to the team
            </a>
          </div>
        </div>
      </section>

      <section>
        <div className="wrap">
          <div className="channel-list">
            {wealthChannels.map((c, i) => (
              <article className="channel" key={i}>
                <div className="channel-head">
                  <div className="channel-num">0{i + 1}</div>
                  <div>
                    <div className="eyebrow">{c.eyebrow}</div>
                    <h2 className="channel-title">{c.title}</h2>
                  </div>
                </div>
                <p className="channel-body">{c.body}</p>

                {c.items && (
                  <div className="channel-items">
                    {c.items.map((it, j) => (
                      <div className="channel-item" key={j}>
                        <span className="ci-label">{it.label}</span>
                        <span className="ci-text">{it.text}</span>
                      </div>
                    ))}
                  </div>
                )}

                {c.cta && c.href && (
                  <div className="channel-cta">
                    {c.href.startsWith("/") ? (
                      <Link className="btn btn-primary" to={c.href}>{c.cta} →</Link>
                    ) : (
                      <a className="btn btn-primary" href={c.href} target="_blank" rel="noopener noreferrer">{c.cta} ↗</a>
                    )}
                  </div>
                )}
              </article>
            ))}
          </div>
        </div>
      </section>

      {/* MAYSTONE BLOCK */}
      <section className="funds-section">
        <div className="wrap" style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 64, alignItems: "center" }}>
          <div>
            <div className="eyebrow">Regulated through Maystone</div>
            <h2 style={{ color: "var(--white)", marginTop: 14, maxWidth: "22ch" }}>
              Wealth management is delivered through Maystone Capital Limited.
            </h2>
            <p className="sub spacer-s">
              Maystone Capital Limited is authorised and regulated by the Financial Conduct
              Authority (FRN 758412). Daksfirst Limited operates as an Appointed
              Representative of Maystone for the credit and fund-management activities of the
              group. Wealth management mandates are entered into directly with Maystone.
            </p>
            <a className="btn btn-ghost spacer-m" href="https://maystone.com" target="_blank" rel="noopener noreferrer">
              Visit maystone.com &nbsp;↗
            </a>
          </div>
          <div style={{ display: "flex", justifyContent: "flex-end" }}>
            <a
              href="https://maystone.com"
              target="_blank"
              rel="noopener noreferrer"
              className="ext-logo-tile"
              style={{ height: 220, minWidth: 280, padding: 8 }}
              title="Maystone Capital Limited"
              aria-label="Visit Maystone"
            >
              <img
                src="/logos/maystone.png"
                alt="Maystone Capital Limited"
                loading="lazy"
                style={{ width: "100%", height: "100%", objectFit: "contain" }}
              />
            </a>
          </div>
        </div>
      </section>

      <section className="reg tight">
        <div className="wrap" style={{ gridTemplateColumns: "1fr", textAlign: "center" }}>
          <div className="cell">
            <p className="muted" style={{ color: "var(--navy-70)", fontSize: 15, maxWidth: "70ch", margin: "0 auto" }}>
              Wealth management mandates are open to professional investors and high-net-worth
              individuals as defined under FCA rules. For a portfolio review or to discuss a
              mandate, contact the team.
            </p>
            <a href="mailto:info@daksfirst.com?subject=Wealth%20management%20enquiry" className="btn btn-dark spacer-m">
              Discuss a mandate
            </a>
          </div>
        </div>
      </section>
    </>
  );
}
